<template>
    <div class="fill-height">
        <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="primary" dark class="px-2">
            <v-menu transition="scroll-y-transition" bottom right offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                        <v-icon x-large>mdi-account-circle</v-icon>
                    </v-btn>
                </template>
                <v-list class="list-custom">
                    <v-list-item to="/profile/edit">
                        <v-icon>mdi-account-edit</v-icon>
                        <v-list-item-title class="pl-2">Editar Perfil</v-list-item-title>
                    </v-list-item>
                    <v-list-item to="/profile/password">
                        <v-icon>mdi-account-key</v-icon>
                        <v-list-item-title class="pl-2">Cambiar Clave</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="logout">
                        <v-icon color="error">mdi-close-circle</v-icon>
                        <v-list-item-title class="pl-2 error--text">Cerrar Sesión</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-spacer/>
            <v-toolbar-title>
                <v-img class="mx-3" src="/img/logo-cambiositalo.png" max-height="50px" contain></v-img>
            </v-toolbar-title>
            <v-spacer/>
            <v-btn icon class="mr-2" :to="{ name: 'Claims' }">
                <v-badge offset-x="8" offset-y="10" overlap color="error">
                    <template v-slot:badge>{{ cc }}</template>
                    <v-icon large>mdi-chat</v-icon>
                </v-badge>
            </v-btn>
            <v-menu transition="scroll-y-transition" bottom left offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                        <v-avatar size="36">
                            <img :src="'/img/country/' + user.country + '.png'" :alt="user.country === null ? '' : user.country.toLowerCase()">
                        </v-avatar>
                    </v-btn>
                </template>
                <v-list class="list-custom">
                    <v-list-item v-for="(i, v) in countries" :key="v" @click="country(i.code)" v-if="i.code !== user.country">
                        <v-list-item-avatar>
                            <img :src="'/img/country/'+i.code+'.png'" :title="i.name" :alt="i.name.toLowerCase()" />
                        </v-list-item-avatar>
                        <v-list-item-title>{{ i.name }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>
        <v-main class="mb-14">
            <transition name="fade" mode="out-in">
                <router-view :user="user" @success="update"/>
            </transition>
        </v-main>
        <v-bottom-navigation grow fixed background-color="primary" color="amber lighten-1" dark v-show="user.role === 'Customer'">
            <v-btn class="px-1" to="/">
                <span>Inicio</span>
                <v-icon>mdi-apps</v-icon>
            </v-btn>
            <v-btn class="px-1" to="/calculator">
                <span>Cotizador</span>
                <v-icon>mdi-calculator-variant</v-icon>
            </v-btn>
            <v-btn class="px-1" to="/request">
                <span>Enviar</span>
                <v-icon>mdi-cash-multiple</v-icon>
            </v-btn>
            <v-btn class="px-1" to="/history">
                <span>Historial</span>
                <v-icon>mdi-list-status</v-icon>
            </v-btn>
            <v-btn class="px-1" to="/accounts">
                <span>Contactos</span>
                <v-icon>mdi-account-group</v-icon>
            </v-btn>
        </v-bottom-navigation>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import axios from 'axios';
    import Form from '../helpers/form';
    import { getUA, isIOS, isAndroid } from 'mobile-device-detect';

    export default {
        name: "AdminComponent",
        mixins: [ Form ],
        data: () => ({
            loading: true,
            useragent: getUA,
            iOS: isIOS,
            Android: isAndroid,
            drawer: null,
            countries: [
                { name: 'Brasil', code: 'BRA' },
                { name: 'Chile', code: 'CHL' },
                { name: 'Colombia', code: 'COL' },
                { name: 'Ecuador', code: 'ECU' },
                { name: 'Mexico', code: 'MEX' },
                { name: 'Panama', code: 'PAN' },
                { name: 'Peru', code: 'PER' },
                { name: 'Estados Unidos', code: 'USA' },
                { name: 'Venezuela', code: 'VEN' }
            ],
            user: {
                id: null,
                photo: null,
                name: null,
                country: null,
                role: 'Customer',
                office_id: null,
                account_id: null,
                status: null,
                suspendReason: null
            },
            cc: '0'
        }),
        mounted() {
            this.user = Object.assign(this.user, this.auth);
            this.getCountMessage();
        },
        computed: {
            ...mapGetters({
                auth: 'user'
            })
        },
        methods: {
            async logout() {
                await this.$store.dispatch("logout");
                this.$toast.info('Has cerrado sesion correctamente.', { icon: 'mdi-information' });
                await this.$router.push({name: "Login"});
            },
            country(country) {
                axios.post('/api/country', { country: country })
                    .then((res) => {
                        this.user = res.data.user;
                        this.getOffices();
                        this.$store.dispatch('setUser', res.data);
                        this.$toast.success('¡Has actualizado tu país!', { icon: 'mdi-check-circle' });
                    }).catch(err => {
                        this.handleErrors(err.response.data.errors);
                    });
            },
            getCountMessage() {
                clearTimeout(this.countMessage);
                axios.get('/api/count').then((res) => {
                    if (res.data.v === 'success') {
                        this.cc = res.data.cc;
                    } else {
                        this.$toast.error(res.data.status, {icon: 'mdi-close-circle'});
                    }
                }).catch(err => {
                    this.handleErrors(err.response.data.errors);
                });
                this.countMessage = setTimeout(this.getCountMessage, 30000);
            },
            update() {
                axios.get('/api/profile').then((res) => {
                    this.user = res.data.user;
                    this.$store.dispatch('setUser', res.data);
                    if (this.user.status !== 103) {
                        clearTimeout(this.timeout);
                        this.timeout = setTimeout(this.update, 300000);
                    }
                }).catch(err => {
                    this.handleErrors(err.response.data.errors);
                });
            }
        },
        destroyed() {
            clearTimeout(this.timeout);
        }
    }
</script>

<style scoped>
.list-custom{
    min-height: 48px;
    max-height: 448px;
    overflow-y: auto;
    padding: 0;
}
.v-item-group.v-bottom-navigation .v-btn {
    min-width: 64px;
}
</style>
